module.exports = __webpack_public_path__ + "img/red.2e39bfb3.jpg";